import { z } from "zod";

const httpUrl = z.string().regex(/^https?:\/\//i);

export const CheckoutCardSchema = z.object({
  productTitle: z.string().min(1),
  brand: z.string().min(1),
  variantTitle: z.string().nullable().optional(),
  imageUrl: httpUrl.nullable().optional(),
  quantity: z.number().int().min(1).default(1),
  totalAmount: z.number(),
  currency: z.string().default("USD"),
  checkoutUrl: httpUrl,
  // Bare domain the checkout lands on (e.g. "pickleballcentral.com") — drives
  // the CTA label. Falls back to `${brand}.com` when absent.
  storeDomain: z.string().optional(),
});

export type CheckoutCardData = z.infer<typeof CheckoutCardSchema>;

export function validateCheckoutCard(value: unknown): CheckoutCardData | null {
  const parsed = CheckoutCardSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
